import { Box } from "@mui/material";

// Shared design tokens + status pill for the admin dashboard and its dialogs.

export const INK = "#1e2a45";
export const MUTED = "#6b7488";
export const BORDER = "#eaedf6";

export type Tone = "green" | "red" | "amber" | "blue" | "violet" | "grey";

export const TONES: Record<Tone, { bg: string; color: string }> = {
  green: { bg: "#e6f7ee", color: "#157a47" },
  red: { bg: "#fdecea", color: "#c33a2c" },
  amber: { bg: "#fdf0dd", color: "#a96a05" },
  blue: { bg: "#e7f2fd", color: "#1574c0" },
  violet: { bg: "#ece8fb", color: "#6336cd" },
  grey: { bg: "#eef0f6", color: "#5a6678" },
};

export function Pill({
  tone,
  label,
  dot = false,
}: {
  tone: Tone;
  label: string;
  dot?: boolean;
}) {
  const t = TONES[tone];
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.7,
        px: 1.1,
        py: 0.4,
        borderRadius: 999,
        bgcolor: t.bg,
        color: t.color,
        fontSize: "0.72rem",
        fontWeight: 700,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
      }}
    >
      {dot && (
        <Box
          sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: t.color }}
        />
      )}
      {label}
    </Box>
  );
}
